import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getAjeerData = createAsyncThunk("api/ajeer?type=1", async (token) => {
    try {
        const response = await nodeinstance.get("/ajeer?type=1", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const AjeerDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAjeerData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getAjeerData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getAjeerData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getAjeerData };
export default AjeerDataSlice.reducer;
